import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "./ui/card";

interface PageContentProps {
  children: React.ReactNode;
  footer?: React.ReactNode;
  icon?: React.ReactNode;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  headerActions?: React.ReactNode;
}

export default function PageContent({
  children,
  footer,
  icon,
  title,
  subtitle,
  headerActions,
}: PageContentProps) {
  const hasHeader = title || subtitle;
  return (
    <Card className="grow overflow-auto flex flex-col gap-2">
      {hasHeader && (
        <CardHeader className="flex flex-row justify-between space-y-0 sticky top-0 bg-white/80 backdrop-blur-sm shadow-sm z-10">
          <CardTitle className="flex items-center">
            <span className="shrink-0">{icon}</span>
            <span className="grow flex flex-col">
              {title}
              {subtitle && (
                <span className="font-normal text-sm text-muted-foreground">
                  {subtitle}
                </span>
              )}
            </span>
          </CardTitle>
          {headerActions}
        </CardHeader>
      )}
      <CardContent className="grow flex flex-col py-2">{children}</CardContent>
      {footer && (
        <CardFooter className="sticky bottom-0 bg-white/80 backdrop-blur-sm shadow-sm z-10 pt-4">
          <div className="flex flex-row grow gap-2 justify-end">{footer}</div>
        </CardFooter>
      )}
    </Card>
  );
}
